module.exports = __webpack_public_path__ + "static/media/chairs.c4a049e2.png";